export default (theme) => ({
  title: {
    marginBottom: 12,
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
  },
  contentWrapper: {
    marginTop: 12,
  },
  root: {
    border: `1px solid ${theme.palette.tableBorderColor}`,
    borderRadius: 5,
    borderCollapse: 'unset',
    borderBottomLeftRadius: 0,
    borderBottomRightRadius: 0,
    borderBottom: 0,
  },
  paginationRoot: {
    border: `1px solid ${theme.palette.tableBorderColor}`,
    borderRadius: 5,
    borderCollapse: 'unset',
    borderTop: 0,
    borderTopLeftRadius: 0,
    borderTopRightRadius: 0,
    paddingBottom: 1,
  },
  actionsWrapper: {
    display: 'flex',
    alignItems: 'center',
  },
  numberCell: {
    width: 10,
    padding: 12,
  },
  genderCell: {
    width: '42.5%',
  },
  birthDateCell: {
    width: '42.5%',
  },
  actionsCell: {
    width: '5%',
  },
  hidden: {
    display: 'none',
  },
  answerWrapper: {
    marginBottom: 12,
  },
  uniqueIdCell: {
    width: '10%',
  },
  selectWrapper: {
    paddingRight: 24,
  },
});
